import { Middleware } from '@nuxt/types';

const UserAgentMiddleware: Middleware = function ({ req, store }) {
  const userAgent = process.server ? req.headers['user-agent'] : navigator.userAgent;
  store.commit('setUserAgent', userAgent);
};

export default UserAgentMiddleware;
